import { useEffect } from "react";
import Lenis from "lenis";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import SkillsMarquee from "@/components/SkillsMarquee";
import About from "@/components/About";
import LongFormProjects from "@/components/LongFormProjects";
import ShortFormProjects from "@/components/ShortFormProjects";
import MotionGraphics from "@/components/MotionGraphics";
import FramesGallery from "@/components/FramesGallery";
import CTA from "@/components/CTA";
import Footer from "@/components/Footer";

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <div className="relative min-h-screen overflow-x-clip bg-ink font-body text-slate-50">
            <div className="noise" aria-hidden="true" />
            <Navbar />
            <main>
                <Hero />
                <SkillsMarquee />
                <About />
                <LongFormProjects />
                <ShortFormProjects />
                <MotionGraphics />
                <FramesGallery />
                <CTA />
            </main>
            <Footer />
        </div>
    );
}

export default App;
